import React from 'react';
import { ApMenu, ApMenuItem, ApButtonIcon } from '@alixpartners/ui-components';
import { Text, Wrapper } from './ContextualMenu.styles';

export const ContextualMenu = ({
	onEdit,
	onDuplicate,
	onDelete,
	toggleMenu,
	isOpen,
	onClose,
	isPaymentTerms,
	showTopVendors,
}) => {
	return (
		<Wrapper>
			<ApMenu
				onClose={onClose}
				isOpen={isOpen}
				toggleMenu={toggleMenu}
				placement="bottom-start"
				button={
					<ApButtonIcon
						iconName="outline_more_vert"
						onClick={e => e.stopPropagation()}
					/>
				}
			>
				<ApMenuItem onClick={onEdit}>
					<Text>Edit</Text>
				</ApMenuItem>
				{!isPaymentTerms && (
					<ApMenuItem onClick={onDuplicate}>
						<Text>Duplicate</Text>
					</ApMenuItem>
				)}
				{showTopVendors && (
					<ApMenuItem onClick={showTopVendors}>
						<Text>Top vendors</Text>
					</ApMenuItem>
				)}
				<ApMenuItem onClick={onDelete}>
					<Text>Delete</Text>
				</ApMenuItem>
			</ApMenu>
		</Wrapper>
	);
};

export default ContextualMenu;
